import React from "react";
import { useForm } from "react-hook-form";
import backend from "../../../api";
import { Notification } from "../../../utils";

export default function DACForm() {
  const { handleSubmit, register, errors, getValues } = useForm();

  const submitForm = async () => {
    const val = getValues();
    if (val) {
      const status = new Notification();
      try {
        const payload = {
          participantInformation: {
            name: val.participant_name,
            email: val.participant_email,
            birthdate: val.participant_birthdate,
          },
          parentGuardianInformation: {
            parentName: val.parent_name,
            parentEmail: val.parent_email,
          },
          agreedAndConfirmed: {
            parentName: val.parent_signature_name,
            date: val.signature_date,
          },
        };

        const { data } = await backend.post("/dac/create", payload);
        status.set_toast("success", data.message);
        status.show_toast();
      } catch (error) {
        status.set_toast(
          "error",
          error.response ? error.response.data.message : error.message
        );
        status.show_toast();
      }
    }
  };

  return (
    <div>
      <section className="about-page section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mb-4">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/c5m.png`}
                  alt="C5M Logo"
                  style={{ maxHeight: "100px" }}
                  className="img-fluid"
                />
                <h3 className="mt-3 font-weight-bold">
                  PARENTAL CONSENT FORM TO PARTICIPATE IN eksplode!'s DIGITAL AD
                  CARD (DAC) PROGRAM BY A MINOR
                </h3>
              </div>

              <h5 className="font-weight-bold mt-3">About eksplode!:</h5>
              <p>
                eksplode! is the interactive division of Continent 5 Media
                Group, Inc. (C5M), offering innovative programs that blend
                creativity and engagement with digital advertising. Participants
                earn rewards by promoting brands through activities like sharing
                digital ads, playing ad-based games, or entering contests such
                as the Video Ad Contest (VAC). Designed to inspire creativity
                and reward participation, eksplode! creates a fun and dynamic
                way for users to interact with advertisements while gaining
                real-world benefits.
              </p>
              <a
                href="https://www.eksplode.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "underline" }}
              >
                Learn more about eksplode!
              </a>

              <h5 className="font-weight-bold mt-3">
                About the Digital Ad Card (DAC) Program:
              </h5>
              <p>
                The DAC Program is an innovative platform where participants
                engage in sharing promotional materials ("Ad Cards") via
                approved social media channels and other digital platforms.
                Participants earn rewards based on their activity, such as
                responsibly sharing and promoting Ad Cards. The program is
                designed to encourage creativity and responsible digital
                engagement while offering participants the opportunity to be
                rewarded for their efforts.
              </p>

              <h5 className="font-weight-bold mt-3">
                About the eMoney Network:
              </h5>
              <p className="mb-3">
                The eMoney Network provides a secure and efficient platform for
                collecting and managing earnings. Parents and participants can
                choose from the following options for managing these earnings:
              </p>
              <ul className="list-unstyled ms-3 mb-3">
                <p>
                  <li className="mb-2">
                    • <strong>Parental Management:</strong> Parents can create
                    an eMoney Network account to receive and manage the rewards
                    earned by their child.
                  </li>
                </p>
                <li className="mb-2">
                  <p>
                    • <strong>Minor’s Independent Management:</strong>{" "}
                    Alternatively, with parental consent, minors can establish
                    their own eMoney Network account to directly receive and
                    manage their earnings.
                  </p>
                </li>
              </ul>
              <p>
                This system ensures flexibility and security, allowing
                participants and their families to utilize rewards in a manner
                that best suits their needs.
              </p>
              <a
                href="https://www.emoney.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "underline" }}
              >
                Learn more about the eMoney Network
              </a>

              <h5 className="font-weight-bold mt-3">
                Participant Information:
              </h5>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label font-weight-bold">
                  Name of Program Participant:
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="participant_name"
                    placeholder="Enter Participant's Name"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                    })}
                  />
                  <small className="text-danger">
                    {errors.participant_name && errors.participant_name.message}
                  </small>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label font-weight-bold">
                  Email of Program Participant (if any):
                </label>
                <div className="col-sm-8">
                  <input
                    type="email"
                    className="form-control form-control-sm"
                    name="participant_email"
                    placeholder="Enter Email"
                    ref={register({
                      pattern: {
                        value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  <small className="text-danger">
                    {errors.participant_email &&
                      errors.participant_email.message}
                  </small>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label font-weight-bold">
                  Birthdate of Participant (MM/DD/YYYY):
                </label>
                <div className="col-sm-8">
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="participant_birthdate"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                    })}
                  />
                  <small className="text-danger">
                    {errors.participant_birthdate &&
                      errors.participant_birthdate.message}
                  </small>
                </div>
              </div>

              <h5 className="mt-4 font-weight-bold">
                Parent/Guardian Information:
              </h5>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label font-weight-bold">
                  Name of Parent/Guardian:
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="parent_name"
                    placeholder="Enter Parent's Name"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                    })}
                  />
                  <small className="text-danger">
                    {errors.parent_name && errors.parent_name.message}
                  </small>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label font-weight-bold">
                  Email Address of Parent:
                </label>
                <div className="col-sm-8">
                  <input
                    type="email"
                    className="form-control form-control-sm"
                    name="parent_email"
                    placeholder="Enter Parent's Email"
                    ref={register({
                      pattern: {
                        value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  <small className="text-danger">
                    {errors.parent_email && errors.parent_email.message}
                  </small>
                </div>
              </div>

              <h5 className="mt-4 font-weight-bold">
                Verification of Consent:
              </h5>
              <p className="mb-3">
                In order to permit the participant identified above (referred to
                as <strong>“Participant”</strong>) to join the Digital Ad Card
                (DAC) Program, the parent or legal guardian identified above
                (referred to as <strong>“Parent”</strong>) must complete and
                submit this consent form.
              </p>
              <p className="mb-3">Parents have the option to either:</p>
              <ul className="list-unstyled ms-3">
                <li className="mb-2">
                  <p>
                    • Print, sign, and date this form and send a scanned copy to{" "}
                    <strong>Admin@C5M.World</strong>.
                  </p>
                </li>
                <li>
                  <p>
                    • Alternatively, type their name below to provide an
                    electronic signature. By typing their name, the Parent
                    acknowledges that this constitutes their legal electronic
                    signature, which has the same binding effect as a
                    handwritten signature under applicable law.
                  </p>
                </li>
              </ul>

              <h5 className="mt-4 font-weight-bold">Consent Details:</h5>
              <ol className="mb-3">
                <p>
                  <li className="mb-2">
                    1. <strong>Age of Participant:</strong> The Participant is
                    13 years of age or older but under the age of 18.
                  </li>
                </p>
                <p>
                  <li className="mb-2">
                    2. <strong>Authority of Parent:</strong> The Parent is the
                    parent or legal guardian of the Participant.
                  </li>
                </p>
                <p>
                  <li className="mb-2">
                    3. <strong>Authorization:</strong> Parent authorizes the
                    Participant to join the DAC Program according to the
                    Official Rules and the Terms of Use and Privacy Policy as
                    posted on eksplode!’s website{" "}
                    <a
                      href="http://www.eksplode.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "underline" }}
                    >
                      eksplode.com
                    </a>
                    .
                  </li>
                </p>
                <p>
                  <li className="mb-2">
                    4. <strong>Consent:</strong> Parent consents to the
                    collection of personal data from the Participant and the use
                    of the Participant’s personal data by C5M, subject to the
                    Program Rules, the Terms of Use, and the Privacy Policy.
                  </li>
                </p>
                <li>
                  <p>
                    5. <strong>Ratification by Parent:</strong>
                    <ul className="list-unstyled ms-4">
                      <p>
                        <li className="mb-2">
                          ◦ Parent has read, understood, and approved the
                          Program Rules, the Terms of Use, and the Privacy
                          Policy.
                        </li>
                      </p>
                      <p>
                        <li className="mb-2">
                          ◦ Parent confirms they are the legal guardian of the
                          Participant.
                        </li>
                      </p>
                      <p>
                        <li className="mb-2">
                          ◦ Parent agrees to cooperate with C5M as needed to
                          ensure compliance with applicable legal requirements.
                          For example, if requested, Parent will assist in
                          obtaining court approval for this consent form if
                          required by law.
                        </li>
                      </p>
                      <p>
                        <li>
                          ◦ Parent acknowledges that C5M relies on this consent
                          form to permit the Participant’s involvement in the
                          DAC Program.
                        </li>
                      </p>
                    </ul>
                  </p>
                </li>
              </ol>

              <h5 className="mt-4 font-weight-bold">Agreed and Confirmed:</h5>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label font-weight-bold">
                  Parent Name:
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="parent_signature_name"
                    placeholder="Enter Parent's Name"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                    })}
                  />
                  <small className="text-danger">
                    {errors.parent_signature_name &&
                      errors.parent_signature_name.message}
                  </small>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label font-weight-bold">
                  Parent Signature (Typed or Handwritten):
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="parent_signature"
                    placeholder="Enter Signature"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                    })}
                  />
                  <small className="text-danger">
                    {errors.parent_signature && errors.parent_signature.message}
                  </small>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label font-weight-bold">
                  Date:
                </label>
                <div className="col-sm-8">
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="signature_date"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                    })}
                  />
                  <small className="text-danger">
                    {errors.signature_date && errors.signature_date.message}
                  </small>
                </div>
              </div>

              <h5 className="mt-4 font-weight-bold">Contact Information:</h5>
              <p className="mb-3">
                For any questions or assistance, please contact us at{" "}
                <a
                  style={{ textDecoration: "underline" }}
                  href="mailto:Admin@C5M.World"
                >
                  Admin@C5M.World
                </a>
                .
              </p>

              <div className="text-center mt-4">
                <a
                  href="#"
                  className="btn btn-solid ml-3"
                  onClick={handleSubmit(submitForm)}
                >
                  Submit
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
